import { CSSObject } from 'styled-components'
import { StyledNavPillProps, StyledIconContainerProps } from './type'

export const getNavPillStyles = ({ theme }: StyledNavPillProps): CSSObject => {
    return {
        cursor: 'pointer',
        padding: `${theme.spacing[2]}`,
        borderRadius: theme.border.radius[4],
        transition: 'all 0.2s ease-in-out',
        gap: theme.spacing[2],

        '&:hover': {
            backgroundColor: '#E6E6E6'
        }
    }
}

export const getIconContainerStyles = ({
    theme
}: StyledIconContainerProps): CSSObject => {
    return {
        transition: 'all 0.2s ease-in-out'
    }
}
